<template>
  <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" @click.self="$emit('cancel')">
    <div class="bg-white p-6 rounded-[1rem] shadow-lg w-full max-w-md align-center">
       <div class="flex flex-col align-center gap-6">
        <div class="flex align-center justify-center">
        <img class="w-[5.5rem] h-[5.5rem]" src="@/assets/images/ConfirmImagelocal.svg" alt="Confirm icon"></div>
      <div class="flex flex-col align-center text-center gap-2">
      <h2 class="text-lg font-bold "> {{ $t("localization.important_notice") }}</h2>
      <p class=" text-[1rem]">{{ $t("localization.important_notice_text") }}</p>
      </div>
      <div class="flex align-center justify-center  gap-4 w-full flex-row-reverse">
        <button @click="$emit('cancel')" type="button" class="w-[8.5rem] justify-center inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm  font-medium rounded-md text-gray-700 bg-white hover:bg-gray-200 text-[1rem]">{{ $t("localization.discard_changes") }}</button>
        <button  @click="$emit('confirm')" class="w-[8.5rem] px-4 py-2 bg-[rgba(121,128,244,1)] font-medium text-white rounded-[0.5rem] hover:bg-indigo-600 text-[1rem]">{{ $t("localization.save_edit") }}</button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationPopupLocalization",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
